import { Tooltip } from "@mui/material";
import { getMetricExplainations } from "../../../utils/constant";
import { extractDomain } from "../../../utils/helpers";
import classes from "./DashboardComponent.module.css";

function PaginatedRBITableModal({
 data,
 headers,
 isDeltaDisplay,
 getValueCell,
 sourceMapping,
 titleMapping,
 maxRowsPerTable = 6,
 geoLogo,
 llmDomains,
 activeTab,
 brandDomains,
}) {
 const totalPages = Math.ceil(data.length / maxRowsPerTable);
  const metricExplainations = getMetricExplainations();
 const paginatedTables = Array.from({ length: totalPages }).map((_, pageIdx) => {
  const startIdx = pageIdx * maxRowsPerTable;
  const endIdx = startIdx + maxRowsPerTable;
  const pageRows = data.slice(startIdx, endIdx);

  return {
   pageNumber: pageIdx + 1,
   rows: pageRows,
  };
 });

 const renderPageTable = (pageData) => {
  return (
   <div
    key={`page-${pageData.pageNumber}`}
    style={{
     pageBreakAfter:
      pageData.pageNumber < totalPages ? "always" : "auto",
     marginBottom: pageData.pageNumber < totalPages ? "30px" : "0",
     border: "1px solid #e0e0e0",
     padding: "16px",
     borderRadius: "4px",
     backgroundColor: "#fff",
    }}
   >
    {/* <div
     style={{
      textAlign: "right",
      fontSize: "12px",
      color: "#666",
      marginBottom: "8px",
      fontWeight: "bold",
     }}
    >
     Page {pageData.pageNumber} of {totalPages}
    </div> */}

    <table className="table table-striped mb-0">
     <thead>
      <tr className="tblHeader text-center">
       <th
        scope="col"
        style={{
         width: "150px",
         textAlign: "left",
         paddingLeft: "15px",
         verticalAlign: "middle",
        }}
       >
        <div className={classes.table_head_title}>
         <span>
          <Tooltip title={metricExplainations["RBI"]}>
           <span
            style={{
             color: "black",
             fontSize: "1rem",
             fontWeight: "500",
            }}
           >
            RBI
           </span>
          </Tooltip>
         </span>
        </div>
       </th>

       {headers.map((header, idx) => {
        const extractGeo = header
         .split("(")[0]
         .trim()
         .replace(/\s+/g, "");

        return (
         <th
          scope="col"
          key={idx}
          className={classes["comp-logo-header"]}
          style={{
           textAlign: "center",
          }}
         >
          <div className={classes["comp-logos"]}>
           {activeTab !== "llm" ? (
            geoLogo?.[extractGeo] && (
             <img
              className={classes?.logo}
              src={`https://flagcdn.com/40x30/${geoLogo?.[extractGeo]}.png`}
              alt={header}
              style={{
               marginBottom: "8px",
               display: "block",
               margin: "0 auto 8px",
              }}
              onError={(e) => {
               e.target.style.display = "none";
              }}
             />
            )
           ) : (
            <img
             className={classes?.logo}
             src={
              header === "llm-web"
               ? "/menu.png"
               : extractDomain(llmDomains?.[header]) ===
                "google.com"
                ? "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg"
                : `https://img.logo.dev/${extractDomain(
                 llmDomains?.[header]
                )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`
             }
             alt={header}
             style={{
              marginBottom: "8px",
              display: "block",
              margin: "0 auto 8px",
              maxHeight: "40px",
             }}
             onError={(e) => {
              e.target.style.display = "none";
             }}
            />
           )}
           <span
            style={{
             wordWrap: "break-word",
             textAlign: "center",
             marginTop: "5px",
             fontSize: "12px",
             display: "block",
            }}
           >
            <Tooltip title={header} placement="top">
             <span>{header}</span>
            </Tooltip>
           </span>
          </div>
         </th>
        );
       })}
      </tr>
     </thead>

     <tbody>
      {pageData.rows.map((row, rowIdx) => (
       <tr key={rowIdx}>
        <td
         style={{
          width: "150px",
          textAlign: "left",
          paddingLeft: "15px",
         }}
        >
         {brandDomains?.[row?.attribute] ? (
          <>
           <img
            style={{
             width: "20px",
             height: "20px",
             borderRadius: "6px",
             marginBottom: "5px",
             marginRight: "8px",
             objectFit: "contain",
             display: "inline-block",
            }}
            src={`https://img.logo.dev/${extractDomain(
             brandDomains?.[row?.attribute]
            )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
            alt={row.attribute}
            onError={(e) => {
             e.target.style.display = "none";
            }}
           />
           <Tooltip title={metricExplainations[row.attribute]}>
            <span>{row.attribute}</span>
           </Tooltip>
          </>
         ) : (
          <Tooltip title={metricExplainations[row.attribute]}>
           <span>{row.attribute}</span>
          </Tooltip>
         )}
        </td>
        {row.values.map((val, valIdx) => {
         const isColorApply = true;

         return (
          <td
           key={valIdx}
           style={{
            width: "100px",
            textAlign: "center",
           }}
          >
           {getValueCell(
            { type: "RBI", title: "RBI" },
            val,
            isColorApply,
            valIdx,
            row,
            "grey",
            sourceMapping,
            "RBI",
            val?.explanation || "",
            row.attribute,
            undefined
           )}
          </td>
         );
        })}
       </tr>
      ))}
     </tbody>
    </table>
   </div>
  );
 };

 return (
  <div className="paginated-rbi-tables">
   {paginatedTables.map((pageData) => renderPageTable(pageData))}
  </div>
 );
}

export { PaginatedRBITableModal };